export default __webpack_public_path__ + "static/media/messageSuccess32.915483a0.svg";